import {Component} from "react";

class About extends Component {

    render() {
        return (
            <div id='services'>
                <div className='container'>
                    <div className='section-title text-center'>
                        <h2>Tietoja</h2>
                    </div>
                    <div className='text-center'>
                        <p>
                            Tästä palveluhakemistosta löydät sinua Suonenjoella palvelevat yritykset. Hakemisto on
                            voimassa vuodet 2026-2028. Palveluhakemisto julkaistaan tällä kertaa ainoastaan digitaalisena.
                            Digitaalinen hakemisto mahdollistaa tietojen ajantasaisuuden. Tietoja voi muuttaa, lisätä ja
                            poistaa kesken julkaisukauden, ilmoita tietojen muutoksesta suoraan meille.
                            Palveluhakemiston julkaisijana toimii LC Suonenjoki/Soittu. Päivitämme hakemistoa yritysten
                            lähettämien tietojen pohjalta. Yritykset vastaavat itse tietojensa ajantasaisuudesta.
                            LC Suonenjoki/Soittu on hyväntekeväisyys ja palvelujärjestö. Olemme iloisia voidessamme
                            tehdä hyvää ja palvella tällä hakemistolla niin Suonenjoen asiakkaita, kuin yrityksiäkin.
                        </p>
                        <p>&nbsp;</p>
                        <img src="img/web-logo-white-v2.png" alt='Suonenjoen Palveluhakemisto 2025-2027'/>
                        <p>&nbsp;</p>
                        <p>
                            <a target="_blank" rel="noreferrer" href="https://www.lionsclubsuonenjokisoittu.fi">Lions
                                Club Suonenjoki / Soittu</a> toteuttaa ja ylläpitää sivustoa vapaaehtoistyönä.
                            Yhteistyössä <a target="_blank" rel="noreferrer"
                                            href="https://www.suonenjoki.fi">Suonenjoen
                            Kaupunki</a>.
                        </p>
                    </div>
                    <div className='text-center'>
                        <p>
                            Haluatko lisätä yrityksesi hakemistoon? Onko tiedoissa virheitä? <a
                            href="mailto:palveluhakemisto-tuki@partagames.com">Ota yhteyttä!</a>
                        </p>
                    </div>
                    <div className='text-center'>
                        <p>
                            Tietosuoja: Sivusto ei tallenna käyttäjätietoja eikä käytä evästeitä.
                        </p>
                    </div>
                    <div className='text-center'>
                        <p>&nbsp;</p>
                        <a href='https://www.lionsclubsuonenjokisoittu.fi'><img src='img/lions-logo.png'
                                                                                alt='Lions Club Logo' width='128'
                                                                                height='128'/></a>
                    </div>
                </div>
            </div>
        )
    }

}

export default About;
